import styled, { css } from 'styled-components'
import theme from 'live/services/theme'

export const Row = styled.div`
    display: flex;
    padding: 10px 15px;
    border-bottom: 1px solid ${theme['gray-dark-bg']};

    i {
        opacity: 0;
        transition: 0.3s;
        margin-right: 7px;

        &.fa-plus-circle {
            color: ${theme['link-color']};
        }

        &.fa-trash-alt {
            color: ${theme['brand-danger']};
        }
    }

    &:hover {
        i {
            opacity: 1;
        }
    }

    &.selectable {
        cursor: pointer;
    }

    &.selected {
        background: ${theme['gray-light']};
    }
`
export const Header = styled.div<{ width?: number }>`
    display: flex;
    padding: 10px 15px;
    border-bottom: 1px solid ${theme['gray-dark-bg']};
    background: ${theme['full-page-background']};
`

interface ItemProps {
    width?: number
}

export const RowItem = styled.div<ItemProps>`
    min-width: 50px;
    ${({ width }) =>
        width !== undefined
            ? css`
                  width: ${width}px;
                  min-width: ${width}px;
              `
            : css`
                  flex: 1;
              `}
    text-transform: uppercase;
    color: ${theme['text-color']};
    position: relative;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`
export const HeaderItem = styled.div<ItemProps>`
    position: relative;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    min-width: 50px;
    ${({ width }) =>
        width !== undefined
            ? css`
                  width: ${width}px;
                  min-width: ${width}px;
              `
            : css`
                  flex: 1;
              `}
    > div {
        text-transform: uppercase;
        color: ${theme['text-color']};
        cursor: pointer;
        .fixed {
            position: sticky;
        }
        .fa {
            margin-left: 6px;
            color: ${theme['text-color']};
            margin-right: 13px;
        }
    }
`

export const ItemAction = styled.i`
    display: inline-block;
    color: ${({ color }) => color || theme['link-color']};
    cursor: pointer;
`

export const Body = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
`

export const Container = styled.div`
    display: flex;
    flex: 1;
    width: 100%;
    flex-direction: column;
    position: relative;
`
